import { Synchronizer } from "../../sync/Synchronizer"
import WorkspaceConfig from "./WorkspaceConfig"
import { HttpWorkspaceFetcher } from "./HttpWorkspaceFetcher"
import Logger from "../../logger"
import { WorkspaceConfigContext, WorkspaceConfigStorage } from "./WorkspaceConfigContext"
import { WorkspaceManager } from "../WorkspaceManager"
import WorkspaceConfigFetcher from "./WorkspaceConfigFetcher"
import { WorkspaceMetadata } from "../Workspace"
import { HackleUser } from "../../model/model"
import ObjectUtil from "../../util/ObjectUtil"

export class WorkspaceConfigManager implements WorkspaceManager, WorkspaceConfigFetcher, Synchronizer {
  private context: WorkspaceConfigContext | null = null

  constructor(
    private readonly workspaceConfigStorage: WorkspaceConfigStorage,
    private readonly workspaceFetcher: HttpWorkspaceFetcher
  ) {}

  initialize(): void {
    this.load()
  }

  private load(): void {
    try {
      const context = this.workspaceConfigStorage.get()
      if (context) {
        this.context = context
        Logger.log.debug(`WorkspaceConfig loaded: [modifiedAt=${context.modifiedAt}]`)
      }
    } catch (e) {
      Logger.log.error(`Failed to read WorkspaceConfig from local: ${e}`)
    }
  }

  private store(context: WorkspaceConfigContext | null): void {
    if (ObjectUtil.isNullOrUndefined(context)) return

    this.context = context
    this.workspaceConfigStorage.set(context)
  }

  metadata(): WorkspaceMetadata | null {
    return this.context?.workspace.metadata ?? null
  }

  // The local workspace is not user-scoped; the user argument is ignored.
  workspace(_user: HackleUser): WorkspaceConfig | null {
    return this.context?.workspace ?? null
  }

  async sync(): Promise<void> {
    const lastModified = this.context?.modifiedAt ?? null

    try {
      const context = await this.workspaceFetcher.fetchIfModified(lastModified)
      this.store(context)
    } catch (e) {
      Logger.log.error(`Failed to fetch WorkspaceConfig: ${e}`)
    }
  }

  async close(): Promise<void> {}
}
